import page from './Home.vue';
export default page;


// WEBPACK FOOTER //
// ./src/pages/home/index.js